import React from "react";
import { Spinner } from "react-bootstrap";

export function LoaderTemplate() {
  return (
    <>
      <Spinner animation="grow" variant="success" />
      <Spinner animation="grow" variant="danger" />
      <Spinner animation="grow" variant="warning" />
    </>
  );
}
